import $ from "jquery";

export function leistungenMenu() {
  $(".cpt-selectbox").change(function () {
    var url = $(this).val();
    if (url !== "") {
      $(location).attr("href", url);
    }
  });
}
